<template>
  <div class="">
    <i @click="deleteRoute" class="bi bi-trash h6"></i>
  </div>
</template>

<script>
import {findCustomRoutes} from "@/store/Modules/Site";

export default {
  name: "DeleteRoute",
  methods: {
    findCustomRoutes,
    deleteRoute() {
      if (confirm('ایا از حذف route اطمینان دارید؟')) {
        let validRoutes = this.findCustomRoutes().map(item => item.name)
        let selectedPage = this.$store.getters['Site/getSiteSelectedPage']
        let site = this.$store.getters['Site/getSite']
        let getSiteSelectedLanguage = this.$store.getters['Site/getSiteSelectedLanguage']
        if (validRoutes.indexOf(selectedPage) > -1) {
          delete site[getSiteSelectedLanguage]['pages'][selectedPage]
        }
      }
    }
  }
}
</script>


<style scoped>

</style>